/** Busca sem acento e sem caixa: "joao" acha "João". Mesmo critério do backend. */
export const normalizarBusca = (s: string) =>
  s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

/** `texto` contém `busca`, ignorando acento e caixa. Busca vazia casa com tudo. */
export const contemBusca = (texto: string, busca: string) => normalizarBusca(texto).includes(normalizarBusca(busca.trim()));
